import { WorkInterventionDaysRepository } from "@/api/Repositories";
import { GeneratedWastesRepository } from "@/api/Repositories";

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    list (state, data) {
      state.list = []
      state.list = data
    },
  },
  actions: {
    list ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        WorkInterventionDaysRepository.get(obj)
          .then(response => {
            const data = response.data.data.generated_wastes
            for (let i = 0; i < data.length; i++) {
              const element = data[i]
              element.option = element.waste_type_id
            }
            console.log("list -> data", data)
            commit('list', data)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    create (context, data) {
      return new Promise((resolve, reject) => {
        GeneratedWastesRepository.create(data)
          .then((response) => {
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    edit (context, data) {
      return new Promise((resolve, reject) => {
        GeneratedWastesRepository.update(data)
          .then(() => {
            resolve();
          }).catch(errorEdit => {
            reject(errorEdit);
          });
      });
    },
    delete (context, id) {
      return new Promise((resolve, reject) => {
        GeneratedWastesRepository.delete(id)
          .then(() => {
            resolve();
          })
          .catch(errorDelete => {
            reject(errorDelete);
          });
      });
    }
  }
}
